export default __webpack_public_path__ + "7059fde6fe72c8b02e4bc2b5667d4a31.png";